export default "__VITE_ASSET__f3008ea9__"